(function () {
    const wpGroup = document.querySelector('[class*="wp-container-"]');

    if (wpGroup) {
        const allChildren = document.querySelectorAll('.wp-block-group__inner-container');

        function getChildInnerHtml(child) {
            let orgInner = child.innerHTML,
                newInner = '<div class="row justify-content-center"><div class="col-lg-12 child-col">' + orgInner + '</div></div>';
            child.classList.add('container');
            child.innerHTML = newInner;
        }

        allChildren.forEach(child => {
            getChildInnerHtml(child);
        });
    };

})();